<template>
  <div class="answer_page">
    <banner-top title="" :show-icon-right="false" />
    <Num :show="(userInfo.vipLevel !== 'nv' || isHasParentLock) && lockState" />
    <!-- main部分 -->
    <div class="main" :class="userInfo.vipLevel === 'nv' ? 'mr_mian' : ''">
      <v-touch
        class="wrapper"
        :swipe-options="{ direction: 'horizontal' }"
        @swipeleft="swiperleft"
        @swiperight="swiperRight"
      >
        <img
          v-if="!lockState && showImg"
          id="botsa"
          class="img"
          :src="getPageUrl(answerPageData.answerPicPath)"
        />
        <img
          v-if="lockState && showImg"
          id="botsa"
          class="img"
          :src="getPageUrl(answerPageData.blankPicPath)"
        />

        <div class="fixed_btn" :class="userInfo.vipLevel === 'nv' ? 'nv_fixed_btn' : ''">
          <!-- sv下载空白题 -->
          <!-- <img
            v-if="userInfo.vipLevel !== 'nv'"
            src="https://img.yzcdn.cn/upload_files/2020/05/25/FgIpxthlY-EIlOL-cn5kuu-A1ieG.png"
            @click="svDownload"
          /> -->
          <!-- nv下载空白题 -->
          <!-- <img
            v-if="userInfo.vipLevel === 'nv'"
            src="https://img.yzcdn.cn/upload_files/2020/05/25/FgIpxthlY-EIlOL-cn5kuu-A1ieG.png"
            @click="nvDownload"
          /> -->
          <!-- 放大 -->
          <img
            src="https://img.yzcdn.cn/upload_files/2020/05/25/FhBAFy4mEkJDpvZz9xYyQ-xAf6Ho.png"
            @click="previewUserPics(true)"
          />
        </div>
        <div class="custom-indicator" :class="userInfo.vipLevel === 'nv' ? 'nv_bottom' : ''">
          页码:
          <span>{{ answerPageData.currentPageNo }}</span>
          / {{ answerPageData.maxPageNo }}
        </div>
        <!-- 切图红框 -->
        <div
          v-for="(item, index) in attaches"
          :key="index"
          :style="{
            position: 'absolute',
            borderRadius: 1.5,
            width: item.width * DE + 'px',
            height: item.height * DE + 'px',
            top: item.lty * DE + 'px',
            left: item.ltx * DE + 'px'
          }"
          :class="showBoeder == index ? 'red-border' : ''"
          @click="checked(item, index)"
        >
          <img
            v-if="showBoeder == index && hasAudio(item)"
            :id="`audio${index}`"
            class="en-audio"
            src="/cms/static/images/broadcast.png"
            @click="playAudio(item, index)"
          />
        </div>
      </v-touch>
      <div style="display: none"></div>
    </div>
    <div class="tool">
      <div class="tool_item" @click="back">
        <img src="https://img.yzcdn.cn/upload_files/2020/06/09/FljJwL98s--ad_Hb5v2zbD8P_TrU.png" />
        <span>返回</span>
      </div>
      <div class="tool_item" @click="toMuLu">
        <img src="https://img.yzcdn.cn/upload_files/2020/06/09/Foy_ZOHX54eRzGZbMd45vMXbiJch.png" />
        <span>目录</span>
      </div>
      <div class="tool_item" @click="addMistakes">
        <img
          :src="
            isAdd
              ? 'https://img.yzcdn.cn/upload_files/2020/06/09/Fp4W0ACGVrOzPr5iqWMb0rPsV7HV.png'
              : 'https://img.yzcdn.cn/upload_files/2020/06/09/FtCPg1P2ChwYo8eiHeetf0wjv9uQ.png'
          "
        />
        <span>{{ isAdd ? '移出错题' : '加入错题' }}</span>
      </div>
      <div class="tool_item" @click="toExplain">
        <img src="https://img.yzcdn.cn/upload_files/2020/06/09/Fuy_legRKKiaHErZ_s3x_ukK0d-q.png" />
        <span>{{ hasExpAnswer == 1 ? '看' : '看' }}讲解</span>
      </div>
    </div>
    <!-- 引导蒙层 -->
    <van-overlay :show="show" @click="closeModal('show')">
      <img
        class="gard"
        src="https://img.yzcdn.cn/upload_files/2020/05/25/Fgn-MHealKkogWjTy-LjTJykB_4E.png"
      />
    </van-overlay>

    <!-- vip提供答案特权提醒弹框 -->
    <van-overlay :show="vipTip" @click="closeModal('vipTip')">
      <div class="alert_wrapper alert_vip" @click.stop>
        <div>
          <img
            src="https://img.yzcdn.cn/upload_files/2020/04/29/FkBl8UqUxolQndMvSxGodU931lrM.png"
          />
          <a @click="closeModal('vipTip')"></a>
        </div>
      </div>
    </van-overlay>
    <openVip
      :nv-down-load.sync="nvDownLoad"
      :showjg.sync="showjg"
      :download-grde="downloadGrde"
      @close="closeDown"
      @closejg="closejg"
      @closeGrde="closeGrde"
    />
    <joinBookAlert :is-show.sync="isjoinBook" :workbook_id="workbook_id" />
    <!-- 密卷alert -->
    <mjAlert :mi-svip="miSvip" @toVip="toVip" @closeMj="closeMj" />
    <!-- 音频文件 -->
    <div style="display: none">
      <audio
        v-if="chapterData.audioPath"
        id="audio_oss"
        :src="$env.ossUrl(chapterData.audioPath)"
        preload="none"
      ></audio>
    </div>
  </div>
</template>

<script>
import { Overlay, Toast } from 'vant'
import BannerTop from '@/components/BannerTop'
import { mapGetters } from 'vuex'
import joinBookAlert from './joinBookAlert'
import home_obj from '../../home_obj'
import openVip from './openVip'
import mjAlert from './mjAlert'
import { getCookie, setCookie, getformData, timestamp, uniqueArr, format } from '@/static/js/zjs.js'
import Num from '@/pages/answer/component/closeLock.vue'
import { addMistake, getUserWrongQus, removeMistake } from '@/api/explain'
import { getPageWaterUrl } from '@/static/js/oss'
export default {
  name: '',
  components: {
    [Overlay.name]: Overlay,
    [Toast.name]: Toast,
    joinBookAlert,
    openVip,
    mjAlert,
    Num,
    BannerTop
  },
  data() {
    return {
      vipTip: false, // 会员呈现答案弹框提示
      show: false, // 引导蒙层弹框
      showTop: false, // 显示顶部导航
      isAdd: false, // 是否添加错题
      workbook_id: '', // 书的id
      advertData: [], // 广告的数据源
      query: {}, // router 传过来的参数
      answerPageData: {}, // 单页数据源
      chapterData: {},
      isVip: false, // 是否是vip
      attaches: [], // 错题信息
      showBoeder: 0, // 错题的红外框
      attache: {}, // 错题
      questionId: '', // 错题id
      wrbId: '', // 题目id
      rrt_pageNum_bottom: {}, // 底部广告
      rrt_pageNum_top: {}, // 头部广告
      show_bottom: false, // 底部广告
      show_top: false, // 头部广告
      wrongQusList: [], // 已添加过的错题list
      hasExpAnswer: '', // 看讲解和求讲解btn
      lockState: false, // 根据家长锁状态控制是否显示答案
      userInfo: {}, // 用户信息
      historyId: [],
      visited: [], // 接口请求返回访问过的id
      isjoinBook: false, // 是否加入书架
      isCollect: false, // 判断是否收藏过
      DE: 1, // 切题图片尺寸比例
      todayStr: format('yyyy-MM-dd', new Date()), // 今天日期,
      right: {},
      showImg: false,
      downloadGrde: false, // 下载空白题引导
      wximgurl: '', // 微信预览的imgurl
      nvDownLoad: false, // 非会员下载题
      clickNum: 1,
      showjg: false,
      miSvip: false,
      audioStopTime: '' // 音频停止时间
    }
  },
  computed: {
    ...mapGetters(['isHasParentLock', 'userSettingBookVersion']),
    remOne() {
      return document.body.clientWidth / 10
    }
  },
  created() {
    this.workbook_id = this.$route.query.workbook_id
    this.isCollect = this.$route.query.isCollect
    this.query = this.$route.query
    this.openid = this.$store.openid
    this.isVip = this.$store.userInfo.vipLevel !== 'nv'
    this.userInfo = this.$store.userInfo
  },
  mounted() {
    // 用户首次访问页面引导显示
    if (getCookie('first_visit')) {
      this.show = false
    } else {
      this.$pop.push(() => (this.show = true))
      setCookie('first_visit', true)
    }
    // 埋点
    // if (window._hmt) {
    //   window._hmt.push(['_trackEvent', 'funcTracker', 'visit', '答案页'])
    // }
    // this.showCollectAlert();
    // 非会员状态下展示广告

    if (this.userInfo.vipLevel === 'nv') {
      this.getPageListAdvert()
    }
    // vip提供答案弹框
    if (getCookie('vipalert')) {
      this.vipTip = false
    } else {
      if (this.userInfo.vipLevel !== 'nv') {
        this.$pop.push(() => (this.vipTip = true))
        setCookie('vipalert', true, 1)
      }
    }
    this.showLoading()
    this.renderImg(this.query.chapter, this.query.pageId)
  },
  beforeDestroy() {
    Toast.clear()
  },
  methods: {
    timestamp,
    format,
    getPageUrl(url) {
      return getPageWaterUrl(this.$env.ossUrl(url))
    },
    closeModal(data) {
      this[data] = false
      this.$pop.next()
    },
    showLoading() {
      Toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true,
        className: 'loading',
        icon: 'https://img.yzcdn.cn/upload_files/2020/07/23/Fp2MdaEGjVuocsQKG6oo4WUgz9u8.gif'
      })
    },
    back() {
      this.$router.back()
    },
    closeMj() {
      this.miSvip = false
      this.$router.back()
    },
    toMuLu() {
      this.$router.push({
        path: '/mjCatalogue',
        query: {
          workbook_id: this.workbook_id
        }
      })
    },
    // 查看详情到求讲解页面
    toExplain() {
      if (this.answerPageData.attaches.length <= 0) {
        return
      }
      // 看讲解埋点
      if (window._hmt) {
        window._hmt.push([
          '_trackEvent',
          'funcTracker',
          'click',
          `答案页-${+this.hasExpAnswer === 1 ? '看讲解' : '求讲解'}_click`
        ])
      }
      var hwQuestionId
      if (this.questionId) {
        hwQuestionId = this.questionId
      } else {
        hwQuestionId = this.attaches[0].question.id
      }
      this.$router.push({
        path: '/explain',
        query: {
          questionId: hwQuestionId,
          workbookId: this.workbook_id,
          chapterId: this.answerPageData.chapterId,
          pageId: this.answerPageData.pageId
        }
      })
    },
    closeGrde() {
      this.downloadGrde = false
      this.previewUserPics(false)
    },
    closeDown() {
      this.nvDownLoad = false
    },
    closejg() {
      setCookie('jgAlert', true, 1)
      this.showjg = false
      this.updataGrde()
    },
    // 普通下载空白题
    nvDownload() {
      this.$trackevent({
        type: 'funcTracker',
        action: 'show',
        opt_label: '空白页下载-支付弹框'
      })
      this.nvDownLoad = true
    },
    svDownload() {
      this.$trackevent({
        type: 'funcTracker',
        action: 'click',
        opt_label: '下载空白页'
      })
      // this.clickNum = getCookie('clickNum') ? parseInt(getCookie('clickNum')) + 1 : this.clickNum
      // setCookie('clickNum', this.clickNum, 1)
      // if (getCookie('jgAlert')) {
      //   this.showjg = false
      // } else {
      //   if (this.clickNum == 21) {
      //     this.showjg = false
      //     return false
      //   } else {
      //     this.showjg = false
      //   }
      // }
      this.updataGrde()
    },
    updataGrde() {
      if (getCookie('downloadGrde')) {
        this.downloadGrde = false
        this.previewUserPics(false)
      } else {
        this.downloadGrde = true
        setCookie('downloadGrde', true, 90)
      }
    },
    toVip() {
      window.location.href = '/cms/webapp/home/vipPay/index.html?channel=mj_tc_gn#/sv'
    },
    toLeague() {
      window.location.href = '/cms/webapp/home/info/business.html'
    },
    // 左滑下一下
    swiperleft(e) {
      if (this.answerPageData.currentPageNo == this.answerPageData.maxPageNo) {
        Toast({ duration: 2000, message: '已经是最后一页了' })
        return false
      }
      this.showLoading()
      this.$emit('beforeSwiperForward', e, this.nextLeft, this)
    },
    nextLeft() {
      this.$router.replace({
        path: 'mjAnswerPage',
        query: {
          workbook_id: this.workbook_id,
          chapter: this.answerPageData.chapterId,
          pageId: this.answerPageData.nextPageId,
          isCollect: this.isCollect
        }
      })
      this.renderImg(this.answerPageData.nextChapterId, this.answerPageData.nextPageId)
    },
    // 右滑上一页
    swiperRight(e) {
      if (this.answerPageData.currentPageNo == 1) {
        Toast({ duration: 2000, message: '已经是第一页了' })
        return false
      }
      this.showLoading()
      this.$emit('beforeSwiperBack', e, this.nextRight, this)
    },
    nextRight() {
      this.$router.replace({
        path: 'mjAnswerPage',
        query: {
          workbook_id: this.workbook_id,
          chapter: this.answerPageData.chapterId,
          pageId: this.answerPageData.prePageId,
          isCollect: this.isCollect
        }
      })
      this.renderImg(this.answerPageData.preChapterId, this.answerPageData.prePageId)
    },

    // 放大功能
    previewUserPics(noAnswer) {
      if (noAnswer) {
        this.wximgurl = this.lockState
          ? this.getPageUrl(this.answerPageData.blankPicPath)
          : this.getPageUrl(this.answerPageData.answerPicPath)
      } else {
        this.wximgurl = this.getPageUrl(this.answerPageData.blankPicPath)
      }

      window.wx.previewImage({
        current: this.wximgurl, // 当前显示的图片链接
        urls: this.wximgurl.split(',') // 需要预览的图片链接列表
      })
    },
    // 点击错题
    checked(item, index) {
      this.showBoeder = index
      this.questionId = item.question.id
      this.attache = item
      this.wrbId = item.id
      // 判断该错题是否已经添加过错题册
      if (this.wrongQusList.join(',').indexOf(this.questionId + '') >= 0) {
        this.isAdd = true
      } else {
        this.isAdd = false
      }
      this.hasExpAnswer = item.question.hasExpAnswer
    },
    // 添加错题和移除错题
    async addMistakes() {
      if (this.answerPageData.attaches.length <= 0) {
        return this.$toast('无效操作')
      }
      const preference = this.userSettingBookVersion.map(
        ({ courseId, editionId, editionName }) => ({
          courseId,
          preferenceId: editionId,
          preferenceName: editionName
        })
      )
      const isAdd = this.isAdd
      const api = isAdd ? removeMistake : addMistake
      const bookData = await this.$store.dispatch('mjBook/getBookJSON', {
        workbookId: this.workbook_id
      })
      return api({
        openId: this.openid,
        questionId: this.questionId || this.answerPageData.attaches[0].question.id, // 错题的id
        preference,
        volume: bookData.volume
      }).then((res) => {
        if (res) {
          Toast({ duration: 1000, message: `已${isAdd ? '移出' : '加入'}错题本` })
          this.isAdd = !isAdd
          this.getWrongQusList(this.answerPageData.attaches)
        }
      })
    },
    // 获取指定页面，指定用户的错题列的list
    getWrongQusList(attaches = []) {
      this.wrongQusList = []
      const questionIds = attaches.map((i) => i.question && i.question.id).filter(Boolean)
      if (questionIds.length === 0) return
      getUserWrongQus({
        openid: this.openid,
        questionIds // 页码id
      }).then((res) => {
        console.log('attaches', attaches)
        console.log('wrong ques list', res.data)
        res.data.map((item) => {
          this.wrongQusList.push(item.id)
        })
        var list = this.wrongQusList.join(',')
        if (!this.questionId && this.attaches.length > 0) {
          if (list.indexOf(this.attaches[0].question.id) !== -1) {
            this.isAdd = true
          } else {
            this.isAdd = false
          }
        }
      })
    },
    // 获取广告
    getPageListAdvert() {
      this.$http
        .post(
          '/cms/weixin/hw/getPageListAdvert',
          getformData({
            code: 'rrt_pageNum',
            cCodes: 'rrt_pageNum_bottom,rrt_pageNum_top'
          })
        )
        .then((res) => {
          this.advertData = res.data

          if (res.data.length > 0) {
            this.advertData.map((item) => {
              for (var key in item) {
                if (key == 'rrt_pageNum_bottom') {
                  this.show_bottom = true
                  this.rrt_pageNum_bottom = item['rrt_pageNum_bottom']
                } else {
                  this.show_top = true
                  this.rrt_pageNum_top = item['rrt_pageNum_top']
                }
              }
            })
          }
        })
    },
    renderImg(chapter, pageId) {
      Promise.all([this.getAnswerPageJosn(chapter, pageId), this.getParentLockState()])
        // 初始化数据
        .then(async (resList) => {
          const [pageJSON] = resList
          // 页书籍
          this.answerPageData = pageJSON
          // 章数据
          this.chapterData = pageJSON.chapterJSON

          this.attaches = pageJSON.attaches || [] // 错题部分信息
          // 存储浏览过的pageid
          if (getCookie('dataList' + this.workbook_id)) {
            this.dataList = getCookie('dataList' + this.workbook_id).split(',')
            this.dataList.push(pageJSON.pageId)
            setCookie('dataList' + this.workbook_id, uniqueArr(this.dataList), 1)
          }
          // await this.countWbPageView()
          if (this.userInfo.vipLevel !== 'nv') {
            this.testTongji()
          }
          // 初始化红框
          this.showBoeder = 0
          if (this.attaches.length > 0) {
            this.hasExpAnswer = this.attaches[0].question.hasExpAnswer
          }
          // 错题列表
          this.getWrongQusList(this.answerPageData.attaches)
          return resList
        })
        // 渲染前的鉴定权限
        .then((resList) => {
          return this.$store
            .dispatch('mjBook/checkMjRights', {
              workbookId: +this.workbook_id,
              pageNo: this.answerPageData.currentPageNo
            })
            .then((res) => {
              this.$emit('afterRender', [res.answerView], this)

              return [resList, res.answerView]
            })
        })
        // 渲染图片
        .then(([resList, right]) => {
          // 渲染图片前页面滚动到最顶端
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
          const [pageJSON] = resList
          var imgurl = this.lockState
            ? `${this.$env.ossUrl(pageJSON.blankPicPath)}`
            : `${this.$env.ossUrl(pageJSON.answerPicPath)}`
          // 是vip或者允许看答案页
          if (right || (!this.lockState && pageJSON.answerFree)) {
            this.showImg = true
            this.drawImg(imgurl)
          } else {
            this.miSvip = true
            Toast.clear()
          }
        })
    },
    drawImg(imgurl) {
      // 获取图片的真是高度
      var image = new Image()
      image.src = imgurl
      var _this = this
      image.onload = function() {
        var relWidth = image.width

        var bot = document.getElementById('botsa')
        // 获取到图片的宽度和高度
        var botWidth = bot.width
        _this.DE = botWidth / relWidth

        Toast.clear()
      }
    },
    // 获取单页数据JSON  切题边框尺寸的换算
    async getAnswerPageJosn(chapter, pageId) {
      this.isAdd = false
      return this.$store.dispatch('mjBook/getPageJSON', {
        workbookId: Number(this.workbook_id),
        chapterId: Number(chapter),
        pageId: Number(pageId)
      })

      // return res
    },
    // 获取家长锁的状态
    async getParentLockState() {
      if (getCookie('hwViewLock')) {
        const hwViewLock = getCookie('hwViewLock')
        if (hwViewLock && hwViewLock == '1') {
          this.lockState = true
        } else {
          this.lockState = false
        }
      } else {
        const res = await this.$http.post(
          '/cms/weixin/user/getParentLockState',
          getformData({
            openid: this.openid
          })
        )
        setCookie('hwViewLock', res.data)
        if (res.data && res.data == '1') {
          this.lockState = true
        } else {
          this.lockState = false
        }
      }
      return this.lockState
    },
    // 是否有看本页答案的特权
    async hasAnswerRight() {
      // SVIP 或者是非会员第一页
      const hasVipRight = this.userInfo.vipLevel !== 'nv'
      const pageOne = this.userInfo.vipLevel === 'nv' && this.answerPageData.currentPageNo === 1
      this.right = {
        hasVipRight,
        pageOne
      }
      return {
        hasVipRight,
        pageOne
      }
    },

    // 统计
    testTongji() {
      const {
        openid,
        userInfo: { wbGrade, isRead, isCourse }
      } = this.$store
      if (window.Statistic) {
        window.Statistic.svipTrace({
          app: 'shanxiCms',
          source: 'mopa',
          openid,
          label: home_obj[this.answerPageData.category] || 'workbook',
          label1: this.workbook_id,
          label2: this.answerPageData.pageId,
          wbType: '4',
          userType: (isRead || '') + ':' + (isCourse || ''),
          userGrade: wbGrade
        })
      }
    },
    // 展示
    countWbPageView() {
      if (window.Statistic) {
        const { openid } = this.$store
        var suc = (data) => {
          var joined = getCookie('joined' + this.workbook_id + this.todayStr)

          // 未加入书架的书。
          // 累计浏览同一本书＞5页(可以是同一次也可以是多次)。
          // 身份区分：只向VIP/SVIP提示。
          // 同一本书，每日最多弹出一次
          if (!this.isCollect && this.isVip && data.data > 4 && joined != '1') {
            this.$pop.push(() => (this.isjoinBook = true))
          } else {
            this.isjoinBook = false
          }
        }
        window.Statistic.countWbPageView(
          {
            app: 'shanxiCms',
            openid,
            label: 'workbook',
            label1: this.answerPageData.wbId
          },
          suc
        )
      }
    },
    // 获取切题音频
    hasAudio(item) {
      return (
        this.chapterData.audioPath &&
        item.question &&
        item.question.audioEnd &&
        item.question.audioStart
      )
    },
    // 播放音频
    playAudio(item, index) {
      const audio = document.querySelector('#audio_oss')
      const stop = () => {
        if (audio.currentTime >= +item.question.audioEnd) {
          audio.pause()
          audio.removeEventListener('timeupdate', stop, false)
        }
      }
      if (audio) {
        if (!audio.paused) {
          audio.pause()
        } else {
          this.setCurrentTime(audio, item.question.audioStart)
          audio.removeEventListener('timeupdate', stop, false)
          audio.addEventListener('timeupdate', stop, false)
          audio.play()
        }
      }
    },
    // 设置音频播放时间
    setCurrentTime(audio, time) {
      var audioDom = audio
      if (this.$env.isIos) {
        let firstOpen = true
        var a = function() {
          // 用秒数来显示当前播放进度
          const timeDisplay = Math.floor(audioDom.currentTime)
          if (timeDisplay > 0) {
            if (firstOpen) {
              audioDom.currentTime = time
              firstOpen = false
              audioDom.removeEventListener('timeupdate', a)
            }
          }
        }
        audioDom.addEventListener('timeupdate', a, false)
        if (audioDom.paused) {
          audioDom.play()
          audioDom.pause()
        } else {
          audioDom.play()
        }
      } else {
        audioDom.currentTime = time
      }
    }
  }
}
</script>

<style lang="scss">
.tool {
  height: 1.07rem;
  padding: 0.11rem 1.07rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  .tool_item {
    position: relative;
    img {
      width: 0.53rem;
    }
    span {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      font-size: 0.27rem !important;
      white-space: nowrap;
      font-weight: 400;
      color: rgba(116, 116, 116, 1);
      line-height: 0.27rem;
    }
  }
}
.answer_page {
  .top_catalogue {
    width: 100%;
    height: 1.17rem;
    background: rgba(240, 73, 69, 1);
    opacity: 0.8;
    padding: 0 0.37rem;
    position: fixed;
    top: 0;
    z-index: 9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .back {
      font-size: 0.4rem;
      width: 6rem;
      white-space: nowrap; /*强制在一行显示*/
      text-overflow: ellipsis; /*设置超出内容显示...*/
      overflow: hidden; /*一定不能少 超出的内容进行隐藏*/
      color: white;
      img {
        display: inline-block;
        width: 0.24rem;
        margin-right: 0.2rem;
        position: relative;
        top: 0.05rem;
      }
    }
    .catalogue {
      margin-right: -8px;
      img {
        display: inline-block;
        width: 0.33rem;
        margin-right: 0.11rem;
      }
    }
    span {
      font-size: 0.4rem;
      color: rgba(255, 255, 255, 1);
      line-height: 1.17rem;
    }
  }
  .main {
    margin: 0;
    display: flex;
    margin-top: 1.17rem;
    flex-direction: column;
    text-align: center;
    // height: 100%;
    margin-bottom: 1.56rem;
    .red-border {
      max-width: 99.8%;
      border: 1px dotted rgb(239, 66, 70);
    }
    .en-audio {
      width: 0.9rem;
      position: absolute;
      right: 0;
      top: 0;
    }
    &.mr_mian {
      margin: 0 0 0.2rem 0;
    }
    .wrapper {
      position: relative;
      flex-grow: 1;
      overflow: overlay;
      touch-action: pan-y !important;
    }
    .custom-indicator {
      width: 100%;
      float: right;
      line-height: 0.6rem;
      font-size: 0.32rem;
      color: #999999;
      text-align: right;
      padding-right: 5px;
      color: #999999;
      span {
        font-size: 0.37rem;
        color: #f04945;
      }
      &.nv_bottom {
        bottom: 2.24rem;
      }
    }
    .fixed_btn {
      width: 43px;
      position: fixed;
      bottom: 5.5rem;
      z-index: 1;
      right: 0.18rem;
      &.nv_fixed_btn {
        bottom: 5.5rem;
      }
      img {
        width: 43px;
        margin-bottom: 4px;
      }
    }
    .bottom_operation {
      flex-shrink: 0;
      width: 100%;
      height: 1.56rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 15px 0px rgba(147, 147, 147, 0.2);
      border-radius: 2px;
      padding: 0 0.55rem;
      // margin-top: 0.2rem;
      display: flex;
      align-items: center;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 22;
      // &.fixed {
      //   position: fixed;
      //   bottom: 0;
      // }
      .explain_btn {
        width: 7rem;
      }
      .book_case {
        width: 1.68rem;
        font-size: 0.27rem;
        text-align: center;
        padding: 0.25rem 0;
        margin-right: 10px;
        img {
          width: 0.49rem;
          margin: 0 auto;
          margin-bottom: 0.2rem;
        }
        p {
          font-size: 0.37rem;
          color: #68707d;
          line-height: 0.36rem;
          &.color {
            color: #b6babf;
          }
        }
      }
    }
    .bottom_advertising {
      width: 100%;
      margin-top: 0.2rem;
      position: relative;
      &.haveMistake {
        margin-bottom: 1.5rem;
      }
      .small-title {
        display: inline-block;
        width: 29px;
        height: 16px;
        position: absolute;
        z-index: 11;
        left: 0px;
        top: 0px;
        font-size: 10px !important;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        text-align: center;
      }

      img {
        width: 100%;
      }
      .todo {
        color: #31a7ff;
        width: 100%;
        margin-top: 12px;
        padding: 0 0.35rem;
        font-size: 12px;
        margin-bottom: 12px;
        p {
          display: inline-block;
          width: 50%;
          font-size: 0.32rem;
          position: relative;
          top: -4px;
          text-align: left;
        }
        .text_right {
          text-align: right;
        }
      }
    }
  }

  .top_advertising {
    width: 100%;
    height: 3rem;
    position: relative;
    .small-title {
      display: inline-block;
      width: 29px;
      height: 16px;
      position: absolute;
      z-index: 11;
      left: 0px;
      top: 0px;
      font-size: 10px !important;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 2px;
      text-align: center;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .img {
    width: 100%;
    height: 100%;
    // min-width: 100%;
  }
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 33;

  .gard {
    width: 5.79rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.van-toast {
  background-color: rgba(0, 0, 0, 0.5);
}
.alert {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  .zjs-adver {
    position: relative;
    width: 7.52rem;
    margin: 0 auto;
    margin-top: 0.43rem;
    .bg {
      width: 100%;
      height: 10.97rem;
      background-image: url('https://img.yzcdn.cn/upload_files/2020/04/24/Fj6PnMroIxz21gR6BbsUows0s-kc.png');
      background-size: 100% 100%;
      position: relative;
      .btn {
        position: absolute;
        bottom: 0.68rem;
        left: 50%;
        transform: translateX(-50%);
        div {
          width: 5.57rem;
          height: 1.07rem;
          text-align: center;
          line-height: 1.07rem;
        }
        .btn_top {
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(255, 104, 103, 1);
          border-radius: 0.53rem;
          font-size: 0.45rem;
          color: #ff6867;
          line-height: 0.9rem;
          span {
            font-size: 0.53rem;
            font-weight: 500;
            position: relative;
            top: 2px;
          }
        }
        .btn_bottom {
          margin-top: 0.43rem;
          color: rgba(255, 255, 255, 1);
          font-size: 0.48rem;
          background-size: 100% 100%;
          background-image: url('https://img.yzcdn.cn/upload_files/2020/04/24/FqUExGOVV_P9rGzPILVaGITETl3b.png');
        }
      }
    }

    .zjs-advert-close {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-top: 20px;
      div {
        width: 10%;
        img {
          display: block;
          width: 100%;
        }
      }
    }
    .watch {
      width: 75%;
      position: absolute;
      height: 40px;
      background: transparent;
      bottom: 34%;
      left: 14%;
    }
    .open {
      width: 75%;
      position: absolute;
      height: 42px;
      background: transparent;
      bottom: 21%;
      left: 14%;
    }
  }
}

.alert_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  &.alert_vip {
    width: 100%;
    div {
      position: relative;
    }
    img {
      width: 290px;
    }
    a {
      width: 200px;
      height: 50px;
      position: absolute;
      bottom: 0.7rem;
      margin: 0 auto;
      display: inline-block;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .block {
    width: 7.49rem;
    height: 7.13rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.4rem;
    position: relative;
    img {
      width: 4.49rem;
      position: absolute;
      top: -0.84rem;
      left: 50%;
      transform: translateX(-50%);
    }
    .msg {
      width: 100%;
      text-align: center;
      margin-top: 2.87rem;
      .msg_top {
        font-size: 0.48rem;
        font-weight: 400;
        color: #333333;
        margin-bottom: 0.27rem;
      }
      .msg_bottom {
        margin-bottom: 0.76rem;
        font-size: 0.37rem;
        font-weight: 400;
        color: #999999;
      }
      button {
        width: 5.41rem;
        height: 1.04rem;
        background: linear-gradient(90deg, rgba(255, 139, 62, 1), rgba(239, 66, 70, 1));
        border-radius: 0.52rem;
        font-size: 0.35rem;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 0.33rem;
      }
      .no {
        font-size: 0.32rem;
        font-weight: 400;
        text-decoration: underline;
        color: rgba(178, 178, 178, 1);
      }
    }
  }
}
.downOverlay {
  background-color: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  .down {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .download {
    width: 7.8rem;
  }
  a {
    position: absolute;
    bottom: 0rem;
    display: block;
    width: 100%;
    height: 2rem;
  }
}
.loading {
  i {
    position: absolute;
    top: 1px;
    width: 2.2em;
    height: 2.2em;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .van-toast__text {
    position: absolute;
    top: 72px;
  }
}
</style>
